import React from 'react';
import { dataHooks } from '../../datahooks';
import s from './CategoriesHeader.scss';
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';

export const CategoriesHeader: React.FC<{}> = () => {
  const { t } = useTranslation();

  return (
    <Box direction="vertical" gap={8}>
      <Box direction="vertical" boxSizing="border-box" gap={2}>
        <Text className={s.title} dataHook={dataHooks.HeaderTitle}>
          {t('STEP1_HEADER')}
        </Text>

        <Box direction="vertical" gap={1} dataHook={dataHooks.HeaderSubtitle}>
          <Text className={s.secondarySubtitle} size="medium">
            {t('STEP1_SUB_HEADER_MOBILE')}
          </Text>

          <Text className={s.subtitle}>{t('STEP_SUB_HEADER_CHOOSE')}</Text>
        </Box>
      </Box>
    </Box>
  );
};
